<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">合同执行单</p>
        <p class="sn" @click="alterInputClick('reportNo','报告编号')">
          编号：<span>{{ value.reportNo }}</span>
        </p>
        <div class="table-wrapper">
        <table class="p1">
          <tr>
            <td width="20%"><p><span @click="alterInputClick('orderNo','合同号')">合同号</span>或<span @click="alterInputClick('customer','客户名称')">客户名称</span></p></td>
            <td colspan="3">
              <p>{{ value.orderNo }}|{{value.customer}}</p>
            </td>
            <td width="15%"><p @click="alterInputClick('orderDate','下单日期')">下单日期</p></td>
            <td @click="alterInputClick('orderDate','下单日期')">
              <p>{{ value.orderDate }}</p>
            </td>
          </tr>
          <tr>
            <td><p>产品名称</p></td>
            <td>
              <p>型号</p>
            </td>
            <td>
              <p>数量</p>
            </td>
            <td>
              <p>选用货品状态</p>
            </td>
            <td>
              <p>要求完工日期</p>
            </td>
            <td>
              <p>其他备注信息</p>
            </td> 
          </tr>
          <tr>
            <td @click="alterInputClick('productName1','产品名称')"><p>{{value.productName1}}</p></td>
            <td @click="alterInputClick('model1','型号')">
              <p>{{value.model1}}</p>
            </td>
            <td @click="alterInputClick('amount1','数量')">
              <p>{{value.amount1}}</p>
            </td>
            <td @click="alterInputClick('stat1','选用货品状态')">
              <p>{{value.stat1}}</p>
            </td>
            <td @click="alterInputClick('askDate1','要求完工日期')">
              <p>{{value.askDate1}}</p>
            </td>
            <td @click="alterInputClick('remark1','其他备注信息')">
              <p>{{value.remark1}}</p>
            </td> 
          </tr>
          <tr>
            <td @click="alterInputClick('productName2','产品名称')"><p>{{value.productName2}}</p></td>
            <td @click="alterInputClick('model2','型号')">
              <p>{{value.model2}}</p>
            </td>
            <td @click="alterInputClick('amount2','数量')">
              <p>{{value.amount2}}</p>
            </td>
            <td @click="alterInputClick('stat2','选用货品状态')">
              <p>{{value.stat2}}</p>
            </td>
            <td @click="alterInputClick('askDate2','要求完工日期')">
              <p>{{value.askDate2}}</p>
            </td>
            <td @click="alterInputClick('remark2','其他备注信息')">
              <p>{{value.remark2}}</p>
            </td> 
          </tr>
          <tr>
            <td @click="alterInputClick('productName3','产品名称')"><p>{{value.productName3}}</p></td>
            <td @click="alterInputClick('model3','型号')">
              <p>{{value.model3}}</p>
            </td>
            <td @click="alterInputClick('amount3','数量')">
              <p>{{value.amount3}}</p>
            </td>
            <td @click="alterInputClick('stat3','选用货品状态')">
              <p>{{value.stat3}}</p>
            </td>
            <td  @click="alterInputClick('askDate3','要求完工日期')">
              <p>{{value.askDate3}}</p>
            </td>
            <td @click="alterInputClick('remark3','其他备注信息')">
              <p>{{value.remark3}}</p>
            </td> 
          </tr>
          <tr>
            <td @click="alterInputClick('productName4','产品名称')"><p>{{value.productName4}}</p></td>
            <td @click="alterInputClick('model4','型号')">
              <p>{{value.model4}}</p>
            </td>
            <td @click="alterInputClick('amount4','数量')">
              <p>{{value.amount4}}</p>
            </td>
            <td @click="alterInputClick('stat4','选用货品状态')">
              <p>{{value.stat4}}</p>
            </td>
            <td @click="alterInputClick('askDate4','要求完工日期')">
              <p>{{value.askDate4}}</p>
            </td>
            <td @click="alterInputClick('remark4','其他备注信息')">
              <p>{{value.remark4}}</p>
            </td> 
          </tr>
        </table>
          <table class=p2>
            <tr>
              <td rowspan="6" width="12%"><p>客户要求</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('customerRequirement1','客户要求1')" style="border-bottom:1px dashed #444;"><p><span v-show="value.customerRequirement1">1、</span>{{value.customerRequirement1}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('customerRequirement2','客户要求2')" style="border-bottom:1px dashed #444;border-top:none;"><p><span v-show="value.customerRequirement2">1、</span>{{value.customerRequirement2}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('customerRequirement3','客户要求3')" style="border-bottom:1px dashed #444;border-top:none;"><p><span v-show="value.customerRequirement3">1、</span>{{value.customerRequirement3}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('customerRequirement4','客户要求4')" style="border-bottom:1px dashed #444;border-top:none;"><p><span v-show="value.customerRequirement4">1、</span>{{value.customerRequirement4}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('customerRequirement5','客户要求5')" style="border-top:none;"><p><span v-show="value.customerRequirement5">1、</span>{{value.customerRequirement5}}</p></td>
            </tr>
          </table>
          <table class=p2>
            <tr>
              <td rowspan="5" width="12%"><p>生产要求</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('produceRequirement1','生产要求1')" style="border-bottom:1px dashed #444;"><p><span v-show="value.produceRequirement1">1、</span>{{value.produceRequirement1}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('produceRequirement2','生产要求2')" style="border-bottom:1px dashed #444;border-top:none;"><p><span v-show="value.produceRequirement2">1、</span>{{value.produceRequirement2}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('produceRequirement3','生产要求3')" style="border-bottom:1px dashed #444;border-top:none;"><p><span v-show="value.produceRequirement3">1、</span>{{value.produceRequirement3}}</p></td>
            </tr>
            <tr>
              <td @click="alterInputClick('produceRequirement4','生产要求4')" style="border-top:none;"><p><span v-show="value.produceRequirement4">1、</span>{{value.produceRequirement4}}</p></td>
            </tr>
          </table>
        <div class="p3">
          <p class="sign1" style="height:30pt;">总经理批准：</p>
        </div>
        <table class=p2>
            <tr>
              <td rowspan="2" width="12%"><p>实际执行情况</p></td>
              <td><p>完工日期</p></td>
              <td><p>未按期完成或未达到要求的原因</p></td>
              <td><p>执行人签署</p></td>
            </tr>
            <tr>
              <td style="height:50pt;"><p>{{value.completeDate}}</p></td>
              <td><p>{{value.delayReason}}</p></td>
              <td><p>{{value.executor}}</p></td>
            </tr>
            <tr>
              <td width="12%"><p>结论</p></td>
              <td colspan="3" style="height:60pt;"><p>{{value.conclusion}}</p>
              <p class="sign1" style="position:relative;top:15pt;">总经理：</p></td>
            </tr>
          </table>
          </div>
          <p class="ins">流程：总经办→生产部→总经办（完工后3天内上交总经办，由总经理作执行情况结论，作为生产主管的考评依据）</p>
          <p class="ins">副本一→技术质检部（安排工艺、检验通知、质量控制依据）；</p>
          <p class="ins">副本二→仓库（领料依据） <span>（共一式三份）</span></p>
      </div>
    </div>
    </div>

    <Modal v-model="modalValue.alterValue" :width="1000" :mask-closable="false">
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "heatReport",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      value: {},
      pronumList:[],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      fid: 0,
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: {'正火':process.env.BASE_URL + "img/heat1.jpg",'调质':process.env.BASE_URL + "img/heat2.jpg",}
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "signatureList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "normalReport",
          enid: this.fileId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.value = response.data.content;
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p {
  line-height: 14pt !important;
}

.free-text {
  text-align: left;
  padding: 3pt 10pt;
}

.underline {
  display: inline-block;
  width: 80pt;
  border-bottom: 1px solid #333;
  line-height: 14pt;
  text-align: center;
}

.w1 {
  border: 1px solid #333;
  padding: 10pt;
}

.sub-title {
  margin-top: 30pt;
  text-align: center;
  font-size: 16pt !important;
  font-weight: 600;
  margin-bottom: 10pt;
}

.sign {
  margin-top: 10pt;
  text-align: right;
}

.p1,
.p2,
.p3,
.w1,
.p4,
.p5 {
  border: 1px solid #333;
}

.p1 td {
  padding: 9pt 0;
  height:28pt;
}

.p1 p {
  line-height: 1.2;
}


.sign-span {
  margin-right: 100pt;
  position: relative;
}

.sign-img {
  position: absolute;
  left: 100pt;
  top: 10pt;
  z-index: 10;
}

.sign-item {
  position: absolute;
  left: 50pt;
  white-space: nowrap;
}

.date-span {
  margin-right: 60pt;
  position: relative;
}

.date-item {
  position: absolute;
  left: 30pt;
  white-space: nowrap;
}

.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

input {
  border: none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}

table.p2 td{
  height:28pt;
}

table.p2 td p{
  line-height: 1.2;
}

.p3 {
  border-top:none;
  border-bottom: none;
}


div.p3,div.p4{
  padding: 2pt 10pt;
  position: relative;
}



.date{
  text-align: right;
  padding-right:60pt;
}

.ins{
  font-family: 'KaiTi';
  font-size: 8pt;
  line-height: 1.5;
  text-align: left;
}

.sign1{
  text-align: right;
  padding-right: 100pt;
}

.table-wrapper{
  outline:2px double #666;
}

.p3{
  border-bottom: 2px double #666;
}
</style>